type OfferBundleItem = {
  id: string
  itemType: string
  displayName?: string | null
}

type OfferBundle = {
  id: string
  name: string
  savingsAmount?: number | null
  flightCredits?: Array<OfferBundleFlightCredit>
  cabinTypeMarkups?: Array<OfferBundleFlightCredit>
  termsAndConditions?: string | null
  items?: Array<OfferBundleItem>
  rateCodes?: Array<string | null>
}

type OfferBundleFlightCredit = {
  cabinType?: string | null
  flightCreditAmount?: number | null
}

interface OfferWithBundles {
  bundles?: Array<OfferBundle>
}

function mapBundleItems(items?: Array<OfferBundleItem>): Array<App.CruiseOfferBundleItem> {
  return (items ?? [])
    .filter((item) => !!item.displayName)
    .map((item) => ({
      id: item.id,
      itemType: item.itemType,
      displayName: item.displayName!.trim(),
    }))
}

function mapBundleRateCodes(rateCodes?: Array<string | null>): Array<string> {
  return (rateCodes ?? []).reduce<Array<string>>((acc, rateCode) => {
    const code = rateCode?.trim()
    return code ? [...acc, code] : acc
  }, [])
}

function mapBundleFlightCredits(
  flightCredits?: Array<OfferBundleFlightCredit>,
): Array<App.CruiseOfferBundleFlightCredit> {
  return (flightCredits ?? []).reduce<Array<App.CruiseOfferBundleFlightCredit>>((acc, flightCredit) => {
    const cabinType = flightCredit.cabinType?.trim()
    if (!cabinType) {
      return acc
    }

    return [
      ...acc,
      {
        cabinType,
        flightCreditAmount: flightCredit.flightCreditAmount ?? null,
      },
    ]
  }, [])
}

export function mapCruiseOfferBundle(offer: OfferWithBundles): App.CruiseOffer['bundle'] {
  const [bundle] = offer.bundles ?? []
  if (!bundle) {
    return undefined
  }

  return {
    id: bundle.id,
    name: bundle.name,
    savingsAmount: bundle.savingsAmount ?? null,
    flightCredits: mapBundleFlightCredits(bundle.flightCredits ?? bundle.cabinTypeMarkups),
    termsAndConditions: bundle.termsAndConditions ?? null,
    items: mapBundleItems(bundle.items),
    rateCodes: mapBundleRateCodes(bundle.rateCodes),
  }
}
